import { render } from "./App.vue?vue&type=template&id=32bc22d6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=32bc22d6&lang=css"
script.render = render

export default script